import React from "react";
import { trackLinkOut } from "../../util/tracking";

const linkToSubmissionStatusExplainer = "https://service.elsevier.com/app/answers/detail/a_id/5971/supporthub/publishing/"

const MoreHelpPanel = ({trackingData = {}}) => {
  const trackLinkClicked = () => trackLinkOut(trackingData, linkToSubmissionStatusExplainer);
  return (
    <div className="morehelpbox">
        <h2 className="visible-only-to-screen-reader">Need more help?</h2>
        <div className="needmorehelp">Need more help?</div>
      <a
        href="https://service.elsevier.com/app/answers/detail/a_id/5971/supporthub/publishing/"
        onClick={trackLinkClicked}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="visitsupport">
          Please visit our Journal Article Publishing Support Center
        </div>
      </a>
    </div>
  );
};

export default MoreHelpPanel;
